import {DateRange, RangeType} from '../../types';
import {getMonth, getQuarter, getWeek, getYear} from '../../utils';
import moment from 'moment';


export function sameDay(a: moment.Moment, b: moment.Moment) {
    return a.isSame(b, 'day'); }
export function mkRange(start: moment.Moment, end: moment.Moment): DateRange {
    return [start.clone().startOf('day'), end.clone().endOf('day')];
}

export function isRangeEqual(a?: DateRange, b?: DateRange) {
    if (!hasBoth(a) || !hasBoth(b)) return false;
    return !!a && !!b && sameDay(a[0], b[0]) && sameDay(a[1], b[1]);
}

const hasBoth = (r?: DateRange | null): r is [moment.Moment, moment.Moment] =>
    !!r && !!r[0] && !!r[1];

export function getPresetRange(t: RangeType): DateRange | undefined  {
    switch (t) {
        case RangeType.CurrentMonth: {
            const m = getMonth();
            return mkRange(m.start, m.end);
        }
        case RangeType.PreviousMonth: {
            const m = getMonth(-1);
            return mkRange(m.start, m.end);
        }
        case RangeType.ThisWeek: {
            const w = getWeek(); // your util
            return mkRange(w.start, w.end);
        }
        case RangeType.LastWeek: {
            const w = getWeek(-1);
            return mkRange(w.start, w.end);
        }
        case RangeType.CurrentQuarter: {
            const q = getQuarter();
            return mkRange(q.start, q.end);
        }
        case RangeType.PreviousQuarter: {
            const q = getQuarter(-1);
            return mkRange(q.start, q.end);
        }
        case RangeType.CurrentYear: {
            const y = getYear();
            return mkRange(y.start, y.end);
        }
        case RangeType.PreviousYear: {
            const y = getYear(-1);
            return mkRange(y.start, y.end);
        }
        default:
            return undefined;
    }
};

export function inferRangeTypeFromValue(val?: DateRange): RangeType {
    if (!val || !hasBoth(val)) return RangeType.Custom;
    for (const t of [
        RangeType.CurrentMonth,
        RangeType.PreviousMonth,
        RangeType.ThisWeek,
        RangeType.LastWeek,
        RangeType.CurrentQuarter,
        RangeType.PreviousQuarter,
        RangeType.CurrentYear,
        RangeType.PreviousYear
    ]) {
        const pr = getPresetRange(t);
        if (isRangeEqual(val, pr)) return t;
    }
    return RangeType.Custom;
};
